import {
  Box,
  Drawer,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useEffect, useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { NavBar } from '../NavBar/NavBar';
import { AdminPage } from '../../interfaces/AdminPage';
import { selectedPageAtom } from '../../atoms/Page';

type BaseLayoutProps = {
  page: AdminPage;
};

const DesktopLayout = (props: BaseLayoutProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        height: '100vh',
      }}
    >
      <NavBar />
      <Box
        sx={{
          p: props.page.disablePadding ? 0 : 3,
          display: 'flex',
          flexGrow: 1,
          flexDirection: 'column',
          overflowY: 'auto',
        }}
      >
        {props.page.element}
      </Box>
    </Box>
  );
};

const MobileLayout = (props: BaseLayoutProps) => {
  const selectedPage = useRecoilValue(selectedPageAtom);

  const [showNavbar, setShowNavbar] = useState(false);

  useEffect(() => {
    setShowNavbar(false);
  }, [selectedPage]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
      }}
    >
      <Drawer
        anchor='left'
        open={showNavbar}
        onClose={() => setShowNavbar(false)}
      >
        <NavBar />
      </Drawer>

      <Paper
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1.5,
        }}
      >
        <IconButton onClick={() => setShowNavbar(true)}>
          <MenuIcon />
        </IconButton>

        <Typography variant='h6'>NNET E-Ticaret</Typography>
      </Paper>

      <Box
        sx={{
          flexGrow: 1,
          p: props.page.disablePadding ? 0 : 1.5,
          overflowY: 'auto',
        }}
      >
        {props.page.element}
      </Box>
    </Box>
  );
};

export const BaseLayout = (props: BaseLayoutProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const setSelectedPage = useSetRecoilState(selectedPageAtom);

  useEffect(() => {
    document.title = `${props.page.name} | NNET E-Ticaret`;
    setSelectedPage(props.page.pageType);
  }, [props.page]);

  return isMobile ? <MobileLayout {...props} /> : <DesktopLayout {...props} />;
};
